module.exports = __webpack_public_path__ + "officialStatic/img/pgk.45860a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/pgk.png
// module id = oWxk
// module chunks = 0